import React, {FunctionComponent, ReactNode, useMemo} from 'react';
import { KlButton, KlButtonProps } from '../klButton/klButton.component';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const styles = require('./klResponsiveDialog.component.scss');

type KlDialogActionProps =  {
    buttonCta: ReactNode;
    onClick?: () => void;
    ctaButtonProps?: KlButtonProps;
    secondaryButtonCta?: ReactNode;
    onSecondaryClick?: () => void;
    secondaryCtaButtonProps?: KlButtonProps;
    className?: string;
}

export const KlDialogAction: FunctionComponent<KlDialogActionProps> = (props) => {
    const {buttonCta, onClick, ctaButtonProps, secondaryButtonCta, onSecondaryClick, secondaryCtaButtonProps,
        className} = props;

    const secondaryButton = useMemo(() => {
        return (secondaryButtonCta && onSecondaryClick) ?
            <KlButton className={styles.secondaryButton} text={secondaryButtonCta} onClick={onSecondaryClick}
                      buttonType={'secondary'} size={'large'} {...secondaryCtaButtonProps}/>
            :
            undefined;
    }, [secondaryButtonCta, onSecondaryClick, secondaryCtaButtonProps]);

    return (
        <div className={`${styles.klDialogAction} ${className || ''}`}>
            {secondaryButton}
            <KlButton buttonType={'primary'} size={'large'} className={styles.mainButton} text={buttonCta}
                      onClick={onClick} {...ctaButtonProps}/>
        </div>
    );
};